module.exports = __webpack_public_path__ + "static/videorecibosEN-f8aab5e84dda389eca09a1e07cb128f5.png";